var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profileView"},[_c('v-container',{staticClass:"responsive-height custom-container"},[_c('ProfileBar'),_c('ProfileInfo'),_c('ProfileVerification'),_c('ProfileStatus')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }